import { useEffect, useState } from 'react';

import Spinner from 'react-bootstrap/Spinner'

import Menu from '../../components/MenuABEA';
import constantes from '../../helpers/constanteHelper';
import CardEmpresaAbea from '../../components/CardEmpresaABEA';
import FiltrosEmpresasABEA from '../../components/FiltrosEmpresasABEA';
import TituloNegrito from '../../components/TituloNegrito';

import sheetsService from '../../services/sheetsServiceAbea'

function CatalogoAbeaEmpresas() {
    const [width, setWidth] = useState(window.innerWidth);
    const [empresasSemFiltro, setEmpresasSemFiltro] = useState([])
    const [empresas, setEmpresas] = useState([]);

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        sheetsService.buscarDadosEmpresas().then((empresasBuscadas) => {
            setEmpresas(empresasBuscadas)
            setEmpresasSemFiltro(empresasBuscadas)
        })
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    function aplicarFiltros(valor) {
        if (valor === '' || !valor) {
            setEmpresas(empresasSemFiltro)
        } else {
            setEmpresas(empresasSemFiltro.filter((empresa) => empresa['Empresa']?.toUpperCase().includes(valor.toUpperCase())))
        }
    }

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.ROXO_ABEA }} className='d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'empresas'} />
                <TituloNegrito texto={'Filtros'} />

                <FiltrosEmpresasABEA aplicarFiltros={aplicarFiltros} resolucaoMobile={resolucaoMobile} />

                <div style={{ width: '80vw', gap: '20px' }} className='my-5 d-flex flex-wrap align-items-center justify-content-center'>
                    {empresas.length > 0 ? empresas.map((empresa) => <CardEmpresaAbea key={empresa['Empresa']} empresa={empresa} />) : <div style={{ width: '100vw', minHeight: '100vh', background: constantes.CORES.ROXO_ABEA }} className='d-flex flex-column align-items-center'>
                        <div style={{ height: '50vh', gap: '20px' }} className='mt-5 d-flex flex-column align-items-center justify-content-center text-center'>
                            <Spinner style={{ height: '60px', width: '60px' }} variant='light' />
                            <span className='mt-3' style={{ fontSize: '20px', color: constantes.CORES.BRANCO_PADRAO, paddingLeft: '20px', paddingRight: '20px' }}>Carregando dados...<br />Por gentileza, aguarde alguns instantes.</span>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    );
}

export default CatalogoAbeaEmpresas;
